import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";

@Injectable({
    providedIn: 'root'
})
export class FamilyService {

    public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/families";
    }

    /**Obtiene todas las fomilias y subfamilias*/
    getAll() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<any>(this.url + "/all", { headers: iheaders });
    }

    /**Guarda las familias y subfamilias*/
    postSave(FamilyObject: Object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<any>(this.url + "/save", JSON.stringify(FamilyObject), { headers: iheaders });
    }

    /**Borrar las familias y subfamilias*/
    postDelete(FamilyObject: Object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<any>(this.url + "/delete", JSON.stringify(FamilyObject), { headers: iheaders });
    }

    /**Obtiene todas las fomilias y subfamilias*/
    getFamiliesCatalog() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<any>(this.url + "/catalog", { headers: iheaders });
    }
}
